var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"shrink my-auto",attrs:{"src":require(("@/assets/svg/card-" + _vm.cardThumb + ".svg")),"width":_vm.width,"contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }